import { Container } from "./styles";

const Overlay = ({
    openLogoutOptions
}) => {
    const getClassName = () => {
        const classList = [];
        openLogoutOptions.value && classList.push("opened");
        return classList.join(" ");
    }
    return (
        <Container className={getClassName()} 
            onClick={() => openLogoutOptions.set(false)}>
        </Container>
    );
}

export default Overlay;